<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thiết lập cấu hình đồng bộ dữ liệu</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row v-for="(param, index) in parameters" :key="param.name">
                            <b-col md="9" offset-md="2">
                                <b-form-group :label="param.description"
                                              :label-cols="12"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              v-b-tooltip.focus
                                              :title="param.description">
                                    <template v-if="param.dataType == 2">
                                        <b-form-input type="number"
                                                      v-model="param.value">
                                        </b-form-input>
                                    </template>
                                    <template v-if="param.dataType == 3">
                                        <date-picker v-model="param.value" placeholder="dd/mm/yyyy"></date-picker>
                                    </template>
                                    <template v-if="param.dataType == 1">
                                        <b-form-input type="text"
                                                      v-model="param.value">
                                        </b-form-input>
                                    </template>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="isBTCUser">
                            <b-col md="9">
                                <b-form-group label=""
                                              :label-cols-md="7">
                                    <b-button type="submit" variant="primary">Lưu</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'SyncParameter',
        mixins: [mixins],
        data() {
            return {
                parameters: []
            }
        },
        created() {
            this.loadSytemParamter();
        },
        methods: {
            save() {
                var vm = this;
                this.$services.put('system-parameters/sync', this.parameters).done((response) => {
                    vm.$toastr.s('Cập nhật tham số hệ thống thành công');
                    //vm.$router.push({ path: '/system/system-parameters/create' });
                });
            },
            loadSytemParamter() {
                var vm = this;
                this.$services.get('system-parameters/sync').done((response) => {
                    vm.parameters = response;
                });
            }
        }
    }
</script>
<style scoped>
</style>
